import { render, staticRenderFns } from "./FarmersList.vue?vue&type=template&id=6579056d&scoped=true"
import script from "./FarmersList.vue?vue&type=script&lang=js"
export * from "./FarmersList.vue?vue&type=script&lang=js"
import style0 from "./FarmersList.vue?vue&type=style&index=0&id=6579056d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6579056d",
  null
  
)

export default component.exports